module.exports = __webpack_public_path__ + "static/media/login_page_icon1.f094cc7d.png";